import { defaultConfig } from "@chakra-ui/react";
import { useMediaQuery } from "./useMediaQuery";
export var useDetectMobileViewPort = function () {
    var _a;
    var breakpoints = (_a = defaultConfig.theme) === null || _a === void 0 ? void 0 : _a.breakpoints;
    var breakpoint = breakpoints !== undefined ? breakpoints.lg : "62em";
    var isMobile = useMediaQuery("(max-width: calc(".concat(breakpoint, " - 1px))"));
    return { isMobile: isMobile };
};
